import { useDispatch, useSelector } from "react-redux";
import { useDialogs } from "@toolpad/core/useDialogs";

import { RootState } from "@store/store";
import { setApplicationSelected } from "@store/slices/componentsSlice";
import { Notificacion } from "@components/DialogosSegmentos/Notificacion";
import { useLazyGetApplicationResumeQuery, usePostStatusApplicationMutation } from "@services/api/applications";

export function useChangeStatusApp() {
    const dialogs = useDialogs();
    const dispatch = useDispatch();

    const userSession = useSelector((state: RootState) => state.session.user);
    const applicationSelected = useSelector((state: RootState) => state.components.applicationSelected);

    const [triggerGetAppInfo] = useLazyGetApplicationResumeQuery();
    const [triggerPostStatusApplication] = usePostStatusApplicationMutation();

    const updateStatusApp = async (status: string, disableSequenceCheck: boolean | undefined = undefined) => {
        triggerPostStatusApplication({
            applicationId: applicationSelected.id,
            userName:
                userSession.name?.concat(" ", userSession.last_name ?? "", " ", userSession.last_name_2 ?? "").trim() ??
                "",
            statusCode: status,
            disableSequenceCheck: disableSequenceCheck,
        })
            .then((result) => {
                const params = new URLSearchParams([["q", `id:equals:'${applicationSelected.id}'`]]);
                triggerGetAppInfo(params.toString()).then((result) => {
                    const updatedApp = result.data?.items.at(0);
                    if (updatedApp) dispatch(setApplicationSelected(updatedApp));
                });
            })
            .catch((error) => {
                dialogs.open(Notificacion, {
                    type: "WARNING",
                    text: "Ocurrio un error al cambiar el estado de la solicitud",
                });
            });
    };

    return { updateStatusApp };
}
